export default __webpack_public_path__ + "static/media/soft.9decca57.jpg";